module.exports = __webpack_public_path__ + "static/media/dglogo.856989ae.png";